<span
  class="material-icons pl-2 text-xl"
  (click)="op.toggle($event)"
  pBadge
  [value]="(notifications$ | async).length"
>
  notifications
</span>
<span class="notifi-count" (click)="op.toggle($event)">
  {{ (notifications$ | async).length }}
</span>
<p-overlayPanel #op [showCloseIcon]="true" [focusOnShow]="false">
  <div class="flex gap-2 flex-col notification-content">
    @if (notifications$|async ;as notifications) { @if (notifications.length>0)
    { @for (item of notifications$|async; track item.id) {
    <app-notification-tile [notification]="item"></app-notification-tile>
    } } @else {
    <p>Nothing here, all caught up!</p>
    } }
  </div>
</p-overlayPanel>
